export default __webpack_public_path__ + "static/media/loginM.68b008c1.png";